import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateMiddle',
    standalone: true,
})
export class TruncateMiddlePipe implements PipeTransform {

    constructor() { }

    transform(value: any, limitOfFirst: number, limitOfLast: number, characters: string): string {
        const first = value.substring(0, limitOfFirst);
        const end = value.substring(value.length - limitOfLast);
        return first + characters + end;
    }

}